<template>
  <el-date-picker
    :editable="false"
    class="date-picker"
    @change="change"
    :style="`width: ${width}`"
    :picker-options="pickerOptions"
    v-model="tempData"
    :type="dateType"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    :default-time="['00:00:00', '23:59:59']"
    value-format="yyyy-MM-dd HH:mm:ss">
  </el-date-picker>
</template>

<script>
  export default {
    name: "DateRangePicker",
    props: {
      start: String,
      end: String,
      type: String,
      width: {
        type: String,
        default: "100%",
      },
      dateType: {
        type: String,
        default: "daterange",
      },
    },
    data() {
      return {
        tempData: [this.start, this.end],
        pickerOptions: {},
      }
    },
    watch: {
      start(val) {
        val ? (this.tempData[0] = val) : (this.tempData = null);
      },
      end(val) {
        val ? (this.tempData[1] = val) : (this.tempData = null);
      }
    },
    methods: {
      getDisabledDate(type) {
        switch (type) {
          case "after": return time => time.getTime() < Date.now() - 8.64e7;
          case "before": return time => this.getFormatDate(time) === this.getFormatDate() ? false : time.getTime() > Date.now();
          default: return () => {};
        }
      },
      getFormatDate(time) {
        let now = time ? new Date(time) : new Date();
        let year = now.getFullYear(); //得到年份
        let month = now.getMonth(); //得到月份
        let date = now.getDate(); //得到日期
        month = month + 1;
        month = month.toString().padStart(2, "0");
        date = date.toString().padStart(2, "0");
        return `${year}-${month}-${date}`
      },
      change(val) {
        let start = (val && val[0]) || "";
        let end = (val && val[1]) || "";
        this.$emit("update:start", start);
        this.$emit("update:end", end);
      },
    },
    created() {
      this.pickerOptions.disabledDate = this.getDisabledDate(this.type);
    }
  }
</script>

<style lang="scss">
  .date-picker {
    input {
      cursor: pointer;
    }
  }
</style>
